module.exports = __webpack_public_path__ + "img/boost-1680.33b80c9.png";